<template>
  <div class="ui segments" :class="{ basic: !inList }">
    <div class="ui top attached inverted red menu" v-if="currentlyActive && r.enabled">
      <div class="item">
        <i class="icon alarm outline"></i>
        <span>{{ currentlyActive.message || $t('ALERT_IS_ACTIVE') }}</span>
      </div>
    </div>
    <div
      class="ui"
      :class="{
        'bottom attached red segment': currentlyActive && r.enabled,
        segment: !currentlyActive || !r.enabled,
        basic: !currentlyActive || inList || !r.enabled
      }"
    >
      <alert-log :alertId="r.id" size="large" v-if="r && r.id" />
    </div>
    <div id="rule-container" class="ui segment" :class="{ basic: !inList }">
      <form class="ui info form" autocomplete="off">
        <div class="two fields">
          <div class="fifteen wide field required" :class="{ error: $v.r.name.$error }">
            <!-- Name -->
            <label for="ruleName">{{ $t('ALERT_RULE_NAME') }}</label>
            <input
              id="ruleName"
              type="text"
              :placeholder="$t('ALERT_RULE_NAME')"
              v-model.trim="r.name"
              @click="$v.r.name.$touch()"
            />
          </div>
          <!-- ENABLED -->
          <div class="one wide field">
            <label for="ruleEnabled">{{ $t('ALERT_RULE_ENABLED') }}</label>
            <div class="ui toggle checkbox">
              <input
                id="ruleEnabled"
                type="checkbox"
                v-model="r.enabled"
                @click="$v.r.enabled.$touch()"
              />
              <label></label>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="ui action segment" :class="{ basic: !inList }">
      <h3 class="header capitalize-fl">{{ $tc('ALERT_RULE_CONDITION', 1) }}</h3>
      <p v-html="$t('ALERT_RULE_CONDITION_DESC')"></p>
      <form class="ui info form" autocomplete="off">
        <div class="two fields">
          <!-- Interval -->
          <div class="field" :class="{ error: $v.r.interval.$error }">
            <label for="ruleInterval">{{ $t('ALERT_RULE_INTERVAL') }}</label>
            <div class="ui right labeled input">
              <div class="ui label">{{ $t('EVERY') }}</div>
              <input
                id="ruleInterval"
                type="number"
                min="1"
                :placeholder="$t('ALERT_RULE_INTERVAL')"
                v-model.number="r.interval"
                @click="$v.r.interval.$touch()"
              />
              <div class="ui label">
                {{ $tc('MINUTE', r.interval) }}
              </div>
            </div>
          </div>

          <!-- Hits -->
          <div class="field" :class="{ error: $v.r.hits.$error }">
            <label for="ruleHits">{{ $t('ALERT_RULE_HITS') }}</label>
            <div class="ui right labeled input">
              <div class="ui label">
                {{ $t('REQUIRE') }}
              </div>

              <input
                id="ruleHits"
                type="number"
                :placeholder="$t('ALERT_RULE_HITS')"
                v-model.number="r.hits"
                min="1"
                @click="$v.r.hits.$touch()"
              />
              <div class="ui label">
                {{ $tc('HITS_TO_ACT', r.hits) }}
              </div>
            </div>
          </div>
        </div>
      </form>

      <!-- CONDITION -->
      <!-- Condition can either by a check using a query -->
      <!-- or condication can be a flow run -->
      <div class="ui top attached secondary tabular pointing menu">
        <div
          class="item"
          :class="{ active: !r.condition || r.condition.type === 'query' }"
          @click="switchCondition('query')"
        >
          {{ $t('ALERT_RULE_CONDITION_QUERY') }}
        </div>
        <div
          class="item"
          :class="{ active: r.condition && r.condition.type === 'flow' }"
          @click="switchCondition('flow')"
        >
          {{ $t('ALERT_RULE_CONDITION_FLOW') }}
        </div>
      </div>
      <div class="ui basic segment" v-if="!r.condition || r.condition.type === 'query'">
        <tokenized-input
          :tokens="queryElements"
          :menus="queryMenus"
          :labelText="$t('ALERT_RULE_QUERY_CONDITION_LABEL')"
          @add="onTokenAdd"
          @change="onTokenChange"
          @menuShown="onQueryMenuShown"
          @menuHidden="onQueryMenuHidden"
        >
          <template #queryProp="{ model }">
            <div
              class="ui left labeled tiny query button"
              :class="{ active: menuShownForToken === model.id }"
            >
              <a class="ui tiny query label" :class="{ active: menuShownForToken === model.id }"
                ><span class="prop">{{ model.prop }}</span>
                <span class="op">{{ $t(model.op && model.op.i18n) }}</span>
                <span class="value">{{ model.value }}</span></a
              >
              <div
                class="ui icon tiny button"
                @click.stop="removeToken(model)"
                :class="{ active: menuShownForToken === model.id }"
              >
                <i class="ui close icon"></i>
              </div>
            </div>
          </template>

          <template #queryProp.menu="{ model, token }">
            <div class="ui vertical menu">
              <div class="item">
                <div class="header">{{ $t('ESTERO_SIMPLE_MENU_PROP') }}</div>
                <div class="menu" v-if="conditionProperties && conditionProperties.length > 10">
                  <div class="item">
                    <div class="ui tiny icon input">
                      <input type="text" v-model="propertySearchTerm" />
                      <i class="ui search icon"></i>
                    </div>
                  </div>
                </div>
                <div class="scroller menu">
                  <a
                    v-for="p in model.properties"
                    :key="p"
                    class="item"
                    @click="token.prop = p"
                    :class="{ active: p === token.prop }"
                  >
                    {{ p }}
                  </a>
                </div>
              </div>
              <div class="item">
                <div class="header">{{ $t('ESTERO_SIMPLE_MENU_OPERATOR') }}</div>
                <div class="scroller menu">
                  <a
                    v-for="op in model.operators"
                    :key="op.symbol"
                    class="item"
                    @click="token.op = op"
                    :class="{ active: op.symbol === (token.op && token.op.symbol) }"
                  >
                    {{ $t(op.i18n) }}
                  </a>
                </div>
              </div>
              <div class="item">
                <div class="header">{{ $t('ESTERO_SIMPLE_MENU_VALUE') }}</div>
                <div class="menu">
                  <div class="item">
                    <div class="ui icon input">
                      <input type="text" v-model="token.value" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </tokenized-input>
      </div>
      <!-- FLOW CONDITION -->
      <div class="ui basic segment" v-else>
        <div class="ui message" v-html="$t('ALERT_RULE_FLOW_LAUNCH_HELP')" />
        <!-- Combo box for launch with all flows for app -->
        <div class="field">
          <label>{{ $t('CHOOSE', { thing: $tc('FLOW', 1) }) }}</label>
          <typeahead
            :items="allFlows"
            :current-item="flowName(r.condition.flow)"
            :placeholder-text="$tc('FLOW', 1)"
            :empty-text="$t('NO_SELECTION')"
            @selected="selectConditionFlow"
          />
        </div>
      </div>
    </div>
    <div class="ui segment" :class="{ basic: !inList }">
      <h3 class="header capitalize-fl">
        {{ $tc('ALERT_RULE_ACTION', (r.actions && r.actions.length) || 0) }}
        <div class="ui small circular label" v-if="r.actions && r.actions.length > 0">
          {{ r.actions.length }}
        </div>
        <div class="ui right floated mini green button" @click="onActionAdded">
          <i class="ui plus icon"></i>
          {{ $t('ADD', { thing: $tc('ALERT_RULE_ACTION', 1) }) }}
        </div>
      </h3>
      <p v-html="$t('ALERT_RULE_ACTIONS_DESC')"></p>
      <template v-for="(action, index) in r.actions">
        <AlertAction
          :action="action"
          :key="action.id"
          @change="onActionChanged"
          @delete="onActionDeleted"
          @add="onActionAdded"
        />
        <div
          class="ui divider"
          v-if="index < r.actions.length - 1"
          :key="'divider' + action.id"
        ></div>
      </template>
    </div>
    <div class="ui segment" v-if="inList">
      <button class="ui red labeled mini icon button" @click="$emit('delete', r)">
        <i class="trash icon"></i>
        {{ $t('DELETE', { thing: $tc('ALERT_RULE', 1) }) }}
      </button>
      <button
        class="ui green right floated labeled mini icon button"
        @click="$emit('change', r)"
        :class="{ disabled: $v.$anyError }"
      >
        <i class="checkmark icon"></i>
        {{ $t('UPDATE', { thing: $tc('ALERT_RULE') }) }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ui.segments {
  margin-bottom: 1rem !important;
}

.query.button {
  .op {
    padding-right: 3px;
    padding-left: 3px;
    font-weight: normal;
  }

  .prop,
  .value {
    font-weight: bold;
  }

  margin: 2px;
}

div.segments > .ui.segment:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

div.segments > .ui.basic.segment {
  margin-bottom: 2rem;
}
</style>

<script>
import { required, integer, minValue } from 'vuelidate/lib/validators'
import { TokenizedInput, Typeahead } from 'ui'
import AlertAction from './AlertAction.vue'
import AlertLog from './AlertLog.vue'
import { Estero, EsteroAlertLog } from 'services'
import _ from 'lodash'

export default {
  name: 'AlertRule',

  components: {
    TokenizedInput,
    AlertAction,
    Typeahead,
    AlertLog
  },

  validations: {
    r: {
      name: {
        required
      },
      hits: {
        integer,
        minValue: minValue(1)
      },
      interval: {
        integer,
        minValue: minValue(1)
      }
    }
  },

  props: {
    rule: {
      type: Object,
      required: true
    },
    inList: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    alertLog() {
      return _.find(this.$store.state.estero_alert_log.items, al => al.id === this.r.id)
    },

    currentlyActive() {
      const lastLogEntry = this.alertLog?.log[this.alertLog.log.length - 1]
      return lastLogEntry?.active ? lastLogEntry : null
    },

    allAppsById() {
      return _.keyBy(this.$store.state.application.items, 'id')
    },
    allFlows() {
      return _.map(this.$store.state.flow.items, flow => ({
        ...flow,
        description: this.allAppsById[flow.application]?.name
      }))
    },
    filteredProperties() {
      if (this.propertySearchTerm) {
        return _.filter(
          this.conditionProperties,
          p => p.toLowerCase().indexOf(this.propertySearchTerm.toLowerCase()) >= 0
        )
      }
      return this.conditionProperties
    },
    queryMenus() {
      return [
        {
          template: 'queryProp',
          properties: this.filteredProperties,
          operators: _.values(this.conditionOperators)
        }
      ]
    },
    queryElementsFromCode() {
      // Map the individual elements of the query to queryElements
      return _.filter(
        _.map(
          this.rule?.condition?.query
            ?.replaceAll('(', '')
            .replaceAll(')', '')
            .split(' AND '),
          elm => {
            var operator = _.find(this.conditionOperators, op => op.match && op.match.test(elm))
            if (!operator) return null
            var operands = operator.match.exec(elm)
            return {
              template: 'queryProp',
              id: Math.random() * 1000,
              prop: operands[operator.matchReverseOperands ? 2 : 1]?.trim(),
              op: operator,
              value: operands[operator.matchReverseOperands ? 1 : 2]?.replace(/"/g, '')?.trim()
            }
          }
        ),
        queryElm => queryElm != null
      )
    }
  },

  data() {
    return {
      r: _.cloneDeep(this.rule),
      queryElements: [],
      settingsSearchTerm: null,
      menuShownForToken: null,

      conditionProperties: ['Alerting/Uptime', 'Alerting/Downtime'],
      conditionOperators: Estero.mql.operators
    }
  },

  methods: {
    onActionChanged(action) {
      this.$set(this.r.actions, _.findIndex(this.r.actions, a => a.id === action.id), action)
      //this.$emit('change', this.r)
    },
    onActionDeleted(action) {
      this.$delete(this.r.actions, _.findIndex(this.r.actions, a => a.id === action.id))
      //this.$emit('change', this.r)
    },
    flowName(flowId) {
      return _.find(this.allFlows, { id: flowId })?.name
    },
    resetCondition(type) {
      this.r.condition = {
        type
      }
    },
    selectConditionFlow(flow) {
      this.resetCondition('flow')
      this.r.condition.flow = flow?.id
      this.queryElements = []
    },
    switchCondition(type) {
      this.$set(this.r, 'condition', { ...this.r.condition, type })
    },
    removeToken(token) {
      this.queryElements = _.filter(this.queryElements, q => q.id !== token.id)

      this.$set(this.r.condition, 'query', this.tokensToQuery(this.queryElements))
    },
    onTokenAdd() {
      this.resetCondition('query')

      this.queryElements.push({
        template: 'queryProp',
        id: Math.random() * 1000,
        prop: '?',
        op: this.conditionOperators['=='],
        value: '?'
      })
    },

    onTokenChange() {
      this.$set(this.r, 'condition', {
        type: 'query',
        query: this.tokensToQuery(this.queryElements)
      })
      if (!this.inList) {
        this.$emit('change', this.r)
      }
    },

    formatValue(op, v) {
      if (!op.forceStringArg && (/^\d+$/.test(v) || v === 'true' || v === 'false')) return v
      return op.symbol == 'regex' ? v : `"${v}"`
    },

    tokensToQuery(tokens) {
      return _.reduce(
        _.map(tokens, t => t.op?.gen(t.prop, this.formatValue(t.op, t.value))),
        (memo, clause) => {
          memo = memo ? `(${memo} AND ${clause})` : clause
          return memo
        },
        ''
      )
    },

    onQueryMenuShown(m) {
      this.menuShownForToken = m.token.id
    },
    onQueryMenuHidden() {
      this.menuShownForToken = null
    },

    onActionAdded() {
      if (!this.r.actions) {
        this.$set(this.r, 'actions', [])
      }

      this.r.actions.push({
        id: this.r.actions.length
      })
    }
  },

  mounted() {
    EsteroAlertLog.readAll().then(() => {
      this.queryElements = this.queryElementsFromCode
    })
    this.$v.$touch()
  },

  watch: {
    rule: function(newRule) {
      if (!_.isEqual(newRule, this.r)) {
        this.r = { condition: { type: 'query' }, ..._.cloneDeep(newRule) }
        this.queryElements = this.queryElementsFromCode
      }
    },
    r: {
      handler: function(newRule, oldRule) {
        if (!this.inList) this.$emit('change', newRule)
      },
      deep: true
    }
  }
}
</script>
